import arrayToggle from '@converdy/utils/array-toggle';

export default {
  data() {
    return {
      products: JSON.parse(
        JSON.stringify(this.properties ? this.properties.products : []) || [],
      ),
      allProducts: [],
      lastUpdated: null,
      updateHandler: null,
      inCartProductIds: [],
      selectedOptionIds: [],
      popupState: false, // product-info, added-to-cart, cart, thank-you
      selectedProduct: {},
    };
  },
  created() {
    if (this.properties && this.properties.products) {
      this.products = JSON.parse(JSON.stringify(this.properties.products));
    }
  },
  mounted() {
    this.initListener();

    // Restore selected products and options
    this.inCartProductIds =
      JSON.parse(localStorage.getItem('inCartProductIds')) || [];
    this.selectedOptionIds =
      JSON.parse(localStorage.getItem('selectedOptionIds')) || [];

    this.updateAllProducts();
  },
  watch: {
    'properties.products'(newval) {
      this.products = typeof newval === 'object' ? newval : this.products;
    },
    inCartProductIds: {
      handler(newVal) {
        this.updateLocalStorage('inCartProductIds', newVal);
      },
      deep: true,
    },
    products: {
      handler(newVal) {
        // Copy all product
        this.updateAllProducts();
      },
      deep: true,
    },
    popupState: {
      handler(newVal) {
        this.updateLocalStorage('popupState', newVal);
      },
    },
    selectedProduct: {
      handler(newVal) {
        this.updateLocalStorage('selectedProduct', newVal);
      },
      deep: true,
    },
    options: {
      handler(newVal) {
        this.updateLocalStorage('options', newVal);
      },
      deep: true,
    },
  },
  methods: {
    updateLocalStorage(key, value) {
      let now = new Date().getTime();
      if (now > this.lastUpdated) {
        localStorage.setItem(key, JSON.stringify(value));
        localStorage.setItem('lastUpdated', JSON.stringify(now));
        this.lastUpdated = now;
        this.dispatchUpdateEvent();
      }
    },
    dispatchUpdateEvent() {
      document.dispatchEvent(
        new CustomEvent('localStorageUpdated', {
          detail: {
            inCartProductIds: this.inCartProductIds,
            popupState: this.popupState,
            selectedProduct: this.selectedProduct,
            lastUpdated: this.lastUpdated,
          },
        }),
      );
    },
    initListener() {
      this.updateHandler = (e) => {
        let {lastUpdated, inCartProductIds, popupState, selectedProduct} =
          e.detail;
        if (lastUpdated > this.lastUpdated) {
          this.inCartProductIds = inCartProductIds;
          this.popupState = popupState;
          this.selectedProduct = selectedProduct;
          this.lastUpdated = lastUpdated;
        }
      };
      document.addEventListener('localStorageUpdated', this.updateHandler);
    },

    updateAllProducts() {
      const localStorageProducts =
        JSON.parse(localStorage.getItem('allProducts')) || [];

      const componentProducts = this.products;

      // Merge all products, prevent duplicates
      let allProducts = [...localStorageProducts];

      componentProducts.forEach((componentProduct) => {
        if (
          !allProducts.some((product) => product.id === componentProduct.id)
        ) {
          allProducts.push(componentProduct);
        } else {
          // Replace previous one
          allProducts = replaceObjectInArray(allProducts, componentProduct);
        }
      });

      this.allProducts = JSON.parse(JSON.stringify(allProducts));

      this.updateLocalStorage('allProducts', this.allProducts);
    },
    selectProduct(product) {
      this.selectedProduct = product;
      this.popupState = 'product-info';
    },
    handleRemoveFromCart(productId, popupState) {
      // If already added,remove
      if (this.inCartProductIds.includes(productId)) {
        this.toggleProductFromCart(productId);
      }
      if (this.inCartProductIds.length === 0) {
        this.popupState = false;
      }
      if (typeof popupState !== 'undefined') {
        this.popupState = popupState;
      }
    },
    toggleProductFromCart(productId) {
      this.inCartProductIds = arrayToggle(this.inCartProductIds, productId);
    },
    toggleSelectedOption(option) {
      this.selectedOptionIds = arrayToggle(this.selectedOptionIds, option.id);
    },
    isInCart(productId) {
      return this.inCartProductIds.includes(productId);
    },
    handleAddToCart(productId, popupState = 'added-to-cart') {
      // If already added, don't toggle
      if (!this.isInCart(productId)) {
        this.toggleProductFromCart(productId);
      }
      this.popupState = popupState;
    },
    handleClearCart() {
      this.inCartProductIds = [];
      this.selectedOptionIds = [];
    },
  },
  computed: {
    selectedProducts() {
      return this.allProducts.filter((product) =>
        this.inCartProductIds.includes(product.id || product.name),
      );
    },
    selectedOptions() {
      return this.options.filter((option) =>
        this.selectedOptionIds.includes(option.id || option.name),
      );
    },
    globalProps() {
      return (
        (this.funnelInfo &&
          this.funnelInfo.getGlobalComponentSettings('CInspiration')) ||
        {}
      );
    },
    options() {
      return this.globalProps.options;
    },
  },
  beforeDestroy() {
    document.removeEventListener('localStorageUpdated', this.updateHandler);
  },
};

function replaceObjectInArray(array, newObject) {
  return array.map((item) => (item.id === newObject.id ? newObject : item));
}
